"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash/noop"));
const luxon_1 = require("luxon");
const classnames_1 = __importDefault(require("classnames"));
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
require("react-tippy/dist/tippy.css");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const datasets_1 = require("companion-app-components/flux/datasets");
const transactions_1 = require("companion-app-components/flux/transactions");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const Dump_1 = __importDefault(require("components/Dump"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const ClrField_1 = __importDefault(require("components/QuickenControls/ClrField"));
const SplitsAndDetailsPanel_1 = __importDefault(require("components/SplitsAndDetailsPanel"));
const helpers_1 = require("components/TransactionRegister/helpers");
const selectors_2 = require("data/payees/selectors");
const utils_1 = require("data/accounts/utils");
const selectors_3 = require("data/transactions/selectors");
const utils_2 = require("data/transactions/utils");
const selectors_4 = require("data/datasetSharing/selectors");
const utils_3 = require("utils/utils");
const SaveField_1 = __importDefault(require("./components/SaveField"));
const TagsField_1 = __importDefault(require("./components/TagsField"));
const MenuField_1 = __importDefault(require("./components/MenuField"));
const CloseField_1 = __importDefault(require("./components/CloseField"));
const SplitField_1 = __importDefault(require("./components/SplitField"));
const NotesField_1 = __importDefault(require("./components/NotesField"));
const CheckField_1 = __importDefault(require("./components/CheckField"));
const MatchField_1 = __importDefault(require("./components/MatchField"));
const PayeeField_1 = __importDefault(require("./components/PayeeField"));
const SelectField_1 = __importDefault(require("./components/SelectField"));
const ActionField_1 = __importDefault(require("./components/ActionField"));
const IgnoredField_1 = __importDefault(require("./components/IgnoredField"));
const AccountField_1 = __importDefault(require("./components/AccountField"));
const BalanceField_1 = __importDefault(require("./components/BalanceField"));
const ReviewedField_1 = __importDefault(require("./components/ReviewedField"));
const UserFlagField_1 = __importDefault(require("./components/UserFlagField"));
const PostedOnField_1 = __importDefault(require("./components/PostedOnField"));
const CategoryField_1 = __importDefault(require("./components/CategoryField"));
const AttachmentField_1 = __importDefault(require("./components/AttachmentField"));
const TxnRowAmountField_1 = __importDefault(require("./components/TxnRowAmountField"));
const DoubleAmountField_1 = __importDefault(require("./components/DoubleAmountField"));
const useRefChangeWatcher_1 = __importDefault(require("./useRefChangeWatcher"));
const utils_4 = require("./utils");
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('components/TransactionRegister/TransactionRow/index.tsx');
const isIe = require('is-iexplorer') || (0, utils_3.isOldEdge)(); // eslint-disable-line
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const SHOW_ALL = true;
const msgGrossPaycheck = "Paycheck can't be edited.";
const TransactionRow = (props) => {
    var _a, _b;
    const { id, txn, flashTx, qcardId, longCats, wrapText, scriptId, calendar, callbacks, wrapperId, accountIds, simpleEdit, headerFields, selectedTxns, doubleAmounts, allAccountIds, editDownloaded, showSplitWindow, registerComfort, currEditFieldName, showAccountColors, regEditableFields, showCurrencySymbol, shade = false, lastRow = false, editable = false, showBalance = true, showAccounts = false, refFn, onRowSelect, sizesChanged, onFocusField, isTxnDirty = false, } = props;
    const { classes } = useStyles();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const { getTxnCurrency } = (0, useQCurrency_1.default)();
    const datasetId = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getDatasetId(state));
    const payeeCategoryMap = (0, react_redux_1.useSelector)((state) => (0, selectors_2.getPayeesForAccounts)(state, props));
    const datasetsById = (0, react_redux_1.useSelector)((state) => datasets_1.datasetsSelectors.getDatasetsById(state));
    const transactionsByAccountId = (0, react_redux_1.useSelector)((state) => (0, selectors_3.getTransactionsByAccountId)(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const accountColorForId = (0, react_redux_1.useSelector)((state) => (0, selectors_1.accountColorForId)(state, txn.accountId));
    const scheduledTransactionsById = (0, react_redux_1.useSelector)((state) => scheduled_transactions_1.scheduledTransactionsSelectors.getScheduledTransactions(state));
    const hasWriteAccess = (0, react_redux_1.useSelector)((state) => (0, selectors_4.hasDatasetWriteAccess)(state));
    const isTransferAccountPresent = (0, react_redux_1.useSelector)((state) => (0, selectors_3.isTransferWritableAccountAvailable)(state, txn));
    const dataset = datasetsById.get(datasetId);
    const tagsAsHashes = featureFlags.get('tagsAsHashes');
    const noDateOnBankPending = featureFlags.get('noDateOnBankPending');
    const txnCancelExtraColumn = featureFlags.get('txnCancelExtraColumn');
    const labelPendingAsFuture = featureFlags.get('labelPendingAsFuture');
    const suggestCategoryForUncategorized = featureFlags.get('suggestCategoryForUncategorized');
    const selected = Boolean(selectedTxns === null || selectedTxns === void 0 ? void 0 : selectedTxns.find((selectedTxn) => selectedTxn.id === props.txn.id));
    const [showIcons, setShowIcons] = (0, react_1.useState)(false);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [accountMenuEl, setAccountMenuEl] = (0, react_1.useState)(null);
    const [currencySymbol, setCurrencySymbol] = (0, react_1.useState)((0, utils_4.getCurrencySymbol)({ showCurrencySymbol, txn, getTxnCurrency }));
    const focusField = (0, react_1.useRef)(null);
    const txnRef = (0, react_1.useRef)(txn);
    const prevTxn = (0, react_1.useRef)(txn);
    const prevEditable = (0, react_1.useRef)(editable);
    const prevShowCurrencySymbol = (0, react_use_1.usePrevious)(showCurrencySymbol);
    const isTypeGrossPaycheck = (0, react_1.useRef)(transactions_1.transactionsUtils.isTxnGrossPaycheckType(txn, transactionsByAccountId, scheduledTransactionsById));
    const isC2REnabled = (0, utils_1.isC2REnabledAccount)(txn.accountId);
    const isQueuePmt = (0, react_1.useMemo)(() => { var _a; return utils_4.QUEUE_PAYMENTS.includes((_a = txn.check) === null || _a === void 0 ? void 0 : _a.number); }, [txn.check]);
    const isEditingQueuePmt = Boolean(((_a = txnRef.current) === null || _a === void 0 ? void 0 : _a.id) && isQueuePmt);
    const hasEditAccess = hasWriteAccess && isTransferAccountPresent;
    (0, useRefChangeWatcher_1.default)(focusField, (newFocusField) => {
        if (onFocusField && newFocusField) {
            onFocusField(newFocusField);
        }
    });
    (0, react_1.useEffect)(() => {
        txnRef.current = txn;
    }, [txn]);
    const isBankPending = (0, utils_2.isBankPendingTxn)(txn);
    const isWindowsDataset = datasets_1.datasetsUtils.isWindowsDataset(dataset);
    const updateShowTooltip = (flag) => {
        setShowTooltip(flag);
    };
    (0, react_1.useEffect)(() => {
        if ((prevShowCurrencySymbol !== showCurrencySymbol) || txn !== prevTxn.current) {
            setCurrencySymbol((0, utils_4.getCurrencySymbol)({ showCurrencySymbol, txn, getTxnCurrency }));
        }
        if (editable !== prevEditable.current) {
            prevTxn.current = txn;
        }
    }, [prevShowCurrencySymbol, showCurrencySymbol, txn, prevTxn, getTxnCurrency, editable, prevEditable]);
    (0, react_1.useEffect)(() => {
        if (showTooltip) {
            setTimeout(() => {
                updateShowTooltip(false);
            }, 3000);
        }
    }, [showTooltip]);
    const fieldIsEditableMethod = (fieldPassed) => {
        const options = {
            accountIds,
            editRunningBalance: false,
            scheduledTransactionsById,
            editDownloaded,
            txnCancelExtraColumn,
            showAccountColors,
            headerFields,
            regEditableFields,
            showSplitWindow,
            allAccountIds,
        };
        if (!(0, utils_2.isUnacceptedScheduledTxn)(txn)) {
            return (0, helpers_1.fieldIsEditable)(txn, fieldPassed, options);
        }
        return (0, utils_2.isNextScheduledInstance)(txn, scheduledTransactionsById) && (0, helpers_1.fieldIsEditable)(txn, fieldPassed, options);
    };
    const itemKeydown = (e, fieldPassed, txnPassed) => {
        var _a;
        if (e.key === ' ' || e.key === 'Enter') {
            e.stopPropagation();
            (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, fieldPassed, txnPassed);
        }
    };
    const updateAccountMenuEl = (menuEl) => {
        setAccountMenuEl(menuEl);
    };
    const renderFields = ({ showSplitsAndDetails, showColor }) => {
        // TODO: put back these currently unused props (was getting lint issues), when showAccounts is used again
        // scheduledTransactionsById, usePayeeField, payeeAutoFillCat, payeeAutoFillMemo, payeeAutoFillAmount, 
        // payeeAutoFillTags, payeeShowFillInfoInMenu, sortBy
        var _a;
        const enableAutoFocus = true;
        const amountProposedSign = (!txn.id || Number(txn.amount) === 0) ? (0, utils_2.txnCategorySign)(txn) : null;
        const wrapClass = wrapText ? 'wraptext' : '';
        const txnRow = [];
        let isEditable = true;
        if (isTypeGrossPaycheck.current) {
            isEditable = false;
        }
        else {
            isEditable = !(0, utils_2.isBankOwnedPending)(txn) ? (editable && hasEditAccess) : (editable && !isC2REnabled);
        }
        // Condition for account not synced case
        let isAccountNotSynced = false;
        if (txn.id && ((_a = txn === null || txn === void 0 ? void 0 : txn.coa) === null || _a === void 0 ? void 0 : _a.type) === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT && !allAccountIds.includes(txn.coa.id)) {
            isEditable = false;
            isAccountNotSynced = true;
        }
        let bankPendingClass = '';
        if (isBankPending) {
            bankPendingClass = (0, utils_2.isBankOwnedPending)(txn) ? classes.bankOwnedPendingText : classes.bankPendingText;
        }
        if (!isTxnDirty && txn.id && isQueuePmt) {
            isEditable = false;
        }
        headerFields.forEach((field) => {
            const forceStatic = isEditable && !fieldIsEditableMethod(field);
            const fieldActive = (isEditable && !forceStatic && currEditFieldName === field);
            let staticValue = (<span>{'\u00A0'}</span>);
            const fieldKey = `${scriptId}_${field}_${fieldActive ? 'e' : ''}`;
            const editClass = fieldActive ? 'editable' : '';
            const hoverClass = (fieldActive || !fieldIsEditableMethod(field)) ? '' : classes.editHover;
            const attributes = {
                key: fieldKey,
                id: fieldKey,
                tabIndex: '0',
                onClick: () => { var _a; return (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, field, txn); },
                onKeyDown: (e) => !isEditable && itemKeydown(e, field, txn),
            };
            switch (field) {
                case 'action':
                    txnRow.push(<ActionField_1.default attributes={attributes} SHOW_ALL={SHOW_ALL} txn={txn} editClass={editClass} hoverClass={hoverClass}/>);
                    break;
                case 'security':
                    txnRow.push(<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={(0, classnames_1.default)(classes.regItem, 'accountFieldName', 'protectWidth', wrapClass, editClass, hoverClass)}>
              {SHOW_ALL && <div>{txn.symbol}{txn.symbol && ' / '}{txn.payee}</div>}
            </styles_1.RegListItem>);
                    break;
                case 'quantity':
                    txnRow.push(<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={(0, classnames_1.default)('amount', classes.regItem, 'quantity', editClass, hoverClass)}>
              {SHOW_ALL && <div>{txn.units || '-'}</div>}
            </styles_1.RegListItem>);
                    break;
                case 'price':
                    txnRow.push(<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={(0, classnames_1.default)('amount', classes.regItem, 'protectWidth', editClass, hoverClass)}>
              {SHOW_ALL && <div>{txn.costBasis || '-'}</div>}
            </styles_1.RegListItem>);
                    break;
                // ------------------------------------------------
                // MATCH FIELD
                // ------------------------------------------------
                case 'match':
                    txnRow.push(<MatchField_1.default attributes={attributes} SHOW_ALL={SHOW_ALL} txn={txn}/>);
                    break;
                // ------------------------------------------------
                // REVIEWED FIELD
                // ------------------------------------------------
                case 'reviewed':
                    txnRow.push(<ReviewedField_1.default attributes={attributes} SHOW_ALL={SHOW_ALL} txn={txn} forceStatic={forceStatic} callbacks={callbacks} isWindowsDataset={isWindowsDataset} fieldActive={fieldActive} isTypeGrossPaycheck={isTypeGrossPaycheck.current} showTooltip={showTooltip} updateShowTooltip={updateShowTooltip} scriptId={scriptId} field={field} isAccountNotSynced={isAccountNotSynced} editable={isEditable} canReview={hasWriteAccess}/>);
                    break;
                // ------------------------------------------------
                // FLAG FIELD
                // ------------------------------------------------
                case 'userFlag':
                    txnRow.push(<UserFlagField_1.default attributes={attributes} callbacks={callbacks} editable={isEditable} fieldActive={fieldActive} txn={txn} showIcons={showIcons} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // IGNORED FIELD
                // ------------------------------------------------
                case 'ignored':
                    txnRow.push(<IgnoredField_1.default attributes={attributes} callbacks={callbacks} editable={isEditable} fieldActive={fieldActive} txn={txn} showIcons={showIcons} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // SELECT FIELD or RECURRING ICON FIELD
                // ------------------------------------------------
                case 'select':
                    txnRow.push(<SelectField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} currEditFieldName={currEditFieldName} isAccountNotSynced={isAccountNotSynced} isTypeGrossPaycheck={isTypeGrossPaycheck.current} selected={selected} onRowSelect={onRowSelect} msgGrossPaycheck={msgGrossPaycheck} focusField={focusField} isTxnDirty={isTxnDirty}/>);
                    break;
                // ------------------------------------------------
                // ACCOUNT COLOR FIELD
                // ------------------------------------------------
                case 'accountColor': {
                    if (showAccountColors) {
                        txnRow.push(<AccountField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} wrapClass={wrapClass} showAccountColors={showAccountColors} accountColorForId={accountColorForId} accountMenuEl={accountMenuEl} updateAccountMenuEl={updateAccountMenuEl} editable={isEditable} focusField={focusField} bankPendingClass={bankPendingClass}/>);
                    }
                    break;
                }
                // ------------------------------------------------
                // ACCOUNT NAME FIELD
                // ------------------------------------------------
                case 'account': {
                    if (showAccounts && !showAccountColors) {
                        txnRow.push(<AccountField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} wrapClass={wrapClass} showAccountColors={showAccountColors} accountColorForId={accountColorForId} accountMenuEl={accountMenuEl} updateAccountMenuEl={updateAccountMenuEl} editable={isEditable} focusField={focusField} bankPendingClass={bankPendingClass}/>);
                    }
                    break;
                }
                // ------------------------------------------------
                // POSTED_ON FIELD
                // ------------------------------------------------
                case 'postedOn': {
                    txnRow.push(<PostedOnField_1.default callbacks={callbacks} attributes={attributes} forceStatic={forceStatic} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} noDateOnBankPending={noDateOnBankPending} editClass={editClass} hoverClass={hoverClass} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} showColor={showColor} bankPendingClass={bankPendingClass}/>);
                    break;
                }
                // ------------------------------------------------
                // TAGS FIELD
                // ------------------------------------------------
                case 'tags': {
                    txnRow.push(<TagsField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} field={field} enableAutoFocus={enableAutoFocus} showSplitWindow={showSplitWindow} staticValue={staticValue} wrapClass={wrapClass} editClass={editClass} hoverClass={hoverClass} wrapText={wrapText} tagsAsHashes={tagsAsHashes} focusField={focusField}/>);
                    break;
                }
                // ------------------------------------------------
                // NOTES FIELD
                // ------------------------------------------------
                case 'notes':
                    txnRow.push(<NotesField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} wrapClass={wrapClass} editClass={editClass} hoverClass={hoverClass} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} wrapText={wrapText} field={field} staticValue={staticValue} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // CHECK FIELD
                // ------------------------------------------------
                case 'check':
                    if (txn.check && (txn.check.number || txn.check.memo)) {
                        staticValue = txn.check.number || txn.check.memo;
                    }
                    txnRow.push(<CheckField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} wrapClass={wrapClass} editClass={editClass} hoverClass={hoverClass} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} staticValue={staticValue} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // PAYEE FIELD
                // ------------------------------------------------
                case 'payee':
                    txnRow.push(<PayeeField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} wrapClass={wrapClass} editClass={editClass} hoverClass={hoverClass} bankPendingClass={bankPendingClass} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} accountIds={accountIds} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // CATEGORY FIELD
                // ------------------------------------------------
                case 'category':
                    txnRow.push(<CategoryField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} wrapClass={wrapClass} editClass={editClass} hoverClass={hoverClass} bankPendingClass={bankPendingClass} currEditFieldName={currEditFieldName} wrapperId={wrapperId} longCats={longCats} wrapText={wrapText} showSplitWindow={showSplitWindow} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // SPLIT FIELD
                // ------------------------------------------------
                case 'split': {
                    txnRow.push(<SplitField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} payeeCategoryMap={payeeCategoryMap} suggestCategoryForUncategorized={suggestCategoryForUncategorized} focusField={focusField}/>);
                    break;
                }
                // ------------------------------------------------
                // STATE FIELD
                // ------------------------------------------------
                case 'state': {
                    txnRow.push(<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.statusColumn, !isC2REnabled ? hoverClass : '')} onClick={null}>
              {SHOW_ALL && !((0, utils_2.isBankOwnedPending)(txn) && isC2REnabled) &&
                            <ClrField_1.default value={txn.state} className={classes.select} onChange={(e) => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'state', txn, e.target.value); }} editable={hasEditAccess && fieldIsEditableMethod(field) && !isTypeGrossPaycheck.current && !isEditingQueuePmt} autoFocus={fieldActive}/>}
            </styles_1.RegListItem>);
                    break;
                }
                // ------------------------------------------------
                // ATTACHMENT FIELD
                // ------------------------------------------------
                case 'attachment':
                    txnRow.push(<AttachmentField_1.default attributes={attributes} callbacks={callbacks} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // EXPENSE FIELD
                // ------------------------------------------------
                case 'expense':
                    if (doubleAmounts) {
                        txnRow.push(<DoubleAmountField_1.default field={'expense'} attributes={attributes} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} currencySymbol={currencySymbol} // state
                         amountEditable={fieldIsEditableMethod(field)} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} focusField={focusField}/>);
                    }
                    break;
                // ------------------------------------------------
                // INCOME FIELD
                // ------------------------------------------------
                case 'income':
                    if (doubleAmounts) {
                        txnRow.push(<DoubleAmountField_1.default field={'income'} attributes={attributes} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} currencySymbol={currencySymbol} // state
                         amountEditable={fieldIsEditableMethod(field)} currEditFieldName={currEditFieldName} enableAutoFocus={enableAutoFocus} focusField={focusField}/>);
                    }
                    break;
                // ------------------------------------------------
                // AMOUNT FIELD
                // ------------------------------------------------
                case 'amount':
                    if (!doubleAmounts) {
                        txnRow.push(<TxnRowAmountField_1.default attributes={attributes} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} txn={txn} editClass={editClass} hoverClass={hoverClass} bankPendingClass={bankPendingClass} field={field} fieldIsEditable={fieldIsEditableMethod} currEditFieldName={currEditFieldName} currencySymbol={currencySymbol} enableAutoFocus={enableAutoFocus} amountProposedSign={amountProposedSign} focusField={focusField}/>);
                    }
                    break;
                // ------------------------------------------------
                // BALANCE FIELD
                // ------------------------------------------------
                case 'balance':
                    if (showBalance) {
                        txnRow.push(<BalanceField_1.default attributes={attributes} callbacks={callbacks} SHOW_ALL={SHOW_ALL} txn={txn} field={field} lastRow={lastRow} enableAutoFocus={enableAutoFocus} currencySymbol={currencySymbol} showColor={showColor} hoverClass={hoverClass} bankPendingClass={bankPendingClass} isWindowsDataset={isWindowsDataset} editable={hasWriteAccess}/>);
                    }
                    break;
                // ------------------------------------------------
                // MENU FIELD
                // ------------------------------------------------
                case 'menu': {
                    txnRow.push(<MenuField_1.default attributes={attributes} callbacks={callbacks} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} showSplitsAndDetails={showSplitsAndDetails} field={field} fieldIsEditable={fieldIsEditableMethod} focusField={focusField}/>);
                    break;
                }
                // ------------------------------------------------
                // SAVE FIELD
                // ------------------------------------------------
                case 'save':
                    txnRow.push(<SaveField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} txn={txn} focusField={focusField}/>);
                    break;
                // ------------------------------------------------
                // CLOSE FIELD
                // ------------------------------------------------
                case 'close':
                    if (txnCancelExtraColumn) {
                        txnRow.push(<CloseField_1.default attributes={attributes} forceStatic={forceStatic} callbacks={callbacks} editable={isEditable} SHOW_ALL={SHOW_ALL} fieldActive={fieldActive} focusField={focusField}/>);
                    }
                    break;
                default:
                    log.error(`Bad Field ${field} sent to TransactionRow`);
                    break;
            }
        });
        return txnRow;
    };
    const displayTransactionModal = () => {
        if (isTypeGrossPaycheck.current) {
            dialogAlert('Notification', msgGrossPaycheck, noop_1.default, ['Ok']);
        }
    };
    //
    // This processes the "SAVE" call from the details panels (splits and/or edit details)
    // We give each of those a copy of the txnBeingEdited so that cancel is easy enough, but
    // it is possible that the user can edit the txnBeingEdited from the transaction row while
    // splits and details are open, which can lead to the transaction fields being edited from
    // two places at once.  We need to a) not lose any edited data from the transaction row, and
    // b) resolve conflicts if the data is edited both places.  In this case, the main txn field
    // wins.
    //
    const saveTransaction = (editedTxn, autoSave, txnDirty, splitToggle = undefined) => {
        var _a;
        const txnBeingEdited = txnRef.current;
        const newTxn = editedTxn;
        let localDirtyFlag = false;
        const txnRowChangedProps = (0, utils_2.getTxnDifferences)(txnBeingEdited, prevTxn.current);
        const detailsPanelChangedProps = (0, utils_2.getTxnDifferences)(txnBeingEdited, newTxn);
        // if user changed memo, tags, payee, coa, postedOn, or check number, then we use the
        // version from the main transaction instead of the details panel.  Exception, if tx is split
        // we ignore the apparent coa change
        //
        const txnPropsChanged = txnRowChangedProps.filter((changedProp) => !detailsPanelChangedProps.includes(changedProp));
        txnPropsChanged.forEach((fieldPassed) => {
            switch (fieldPassed) {
                case 'postedOn':
                case 'memo':
                case 'check':
                case 'state':
                case 'payee':
                    newTxn[fieldPassed] = txnBeingEdited[fieldPassed];
                    localDirtyFlag = true;
                    break;
                case 'split':
                    localDirtyFlag = true;
                    break;
                case 'amount':
                case 'tags':
                case 'coa':
                    if (!transactions_1.transactionsUtils.isSplitTxn(newTxn)) {
                        newTxn[fieldPassed] = txnBeingEdited[fieldPassed] || newTxn[fieldPassed]; // don't ever purposefully assign null
                        localDirtyFlag = true;
                    }
                    break;
                default:
                    break;
            }
        });
        (_a = callbacks.saveTransaction) === null || _a === void 0 ? void 0 : _a.call(callbacks, newTxn, autoSave, txnDirty || localDirtyFlag, splitToggle);
    };
    const panelOpen = (showSplitWindow || !simpleEdit) && editable;
    const showColor = !calendar;
    /* eslint-disable prefer-template */
    const className = (shade ? 'shade' : '') +
        (lastRow ? ' lastRow appear' : '') +
        (panelOpen ? ' panel' : '') +
        (editable ? ' editable appear' : '') +
        (` ${registerComfort}${isIe ? '-ie' : ''}`) +
        (luxon_1.DateTime.fromISO(txn.postedOn) > (luxon_1.DateTime.now()) && !labelPendingAsFuture && showColor ? ' pending' : '') +
        ((0, utils_2.isUnacceptedScheduledTxn)(txn) && showColor ? ' pending' : '') +
        ((0, utils_4.getColorClass)(!showColor, txn.amount));
    const showSplitsAndDetails = editable && (showSplitWindow || !simpleEdit);
    const fieldsToRender = renderFields({ showSplitsAndDetails, showColor });
    let isSplitsEditable = true;
    if (isTypeGrossPaycheck.current) {
        isSplitsEditable = false;
    }
    else {
        isSplitsEditable = (0, utils_2.isBankOwnedPending)(txn) ? !isC2REnabled : true;
    }
    if (!isTxnDirty && txn.id && utils_4.QUEUE_PAYMENTS.includes((_b = txn.check) === null || _b === void 0 ? void 0 : _b.number)) {
        isSplitsEditable = false;
    }
    return (<styles_1.RegTxList ref={refFn} aria-label={scriptId} id={id} key={`${txn.id}`} className={className} onMouseEnter={() => setShowIcons(true)} onMouseLeave={() => setShowIcons(false)}>
      <div {...(qcardId ? { id: qcardId } : {})}>
        {/* --------------------------------------------------- */}
        {/* -- ALL ROW FIELDS -- */}
        {/* --------------------------------------------------- */}
        <styles_1.RegTxListRow className={(0, classnames_1.default)(flashTx ? 'flashTx' : '', className)} onClick={isTypeGrossPaycheck.current ? displayTransactionModal : undefined}>
          {fieldsToRender}
          <Dump_1.default obj={txn}/>
        </styles_1.RegTxListRow>

        {/* --------------------------------------------------- */}
        {/* -- SPLITS/DETAILS PANEL -- */}
        {/* --------------------------------------------------- */}
        {showSplitsAndDetails &&
            <SplitsAndDetailsPanel_1.default autoFocus txn={txn} closeFn={() => { var _a; return (_a = callbacks.hideModal) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'splits'); }} saveFn={saveTransaction} deleteFn={() => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'delete', txn); }} onAmountChange={callbacks.onAmountChange} longCats={longCats} showCurrencySymbol={showCurrencySymbol} onSizeChange={sizesChanged} showDetails={!simpleEdit} showSplits={showSplitWindow} unMatchAction={() => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'unMatch', txn); }} goToTransferAction={() => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'transfer', txn); }} getSaveFn={callbacks.detailsRefSaveFn} splitSwitch={(on) => { var _a, _b; return on ? (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'split', txn) : (_b = callbacks.handleMenu) === null || _b === void 0 ? void 0 : _b.call(callbacks, 'hideSplit', txn); }} editable={hasEditAccess && isSplitsEditable}>
          </SplitsAndDetailsPanel_1.default>}
      </div>
    </styles_1.RegTxList>);
};
exports.default = (0, react_1.memo)(TransactionRow);
